import dayjs from 'dayjs';
import { HmacMD5 } from 'crypto-js';

import genericElementPicture from '../imgs/genericElementPicture.jpg';
import store from '../store/store';

export const minutesToMidnight = () => Math.ceil(dayjs().endOf('day').diff(dayjs(), 'minutes', true));

export const getUserLocale = () => {
  const state = store.getState();
  const userLocale = state.i18n.availableLanguages.find(language => language.language === state.user.preferredLanguage);
  return userLocale?.locale || 'fr-FR';
};

export const normalizedString = (param: string) =>
  param
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const chunkArray = <T>(array: T[], size: number): T[][] =>
  Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, i * size + size));

export const capitalizeString = ([first, ...rest]: string) => first.toUpperCase() + rest.join('').toLowerCase();

export const getElementPicture = (value: string, name: string, size: string) => {
  if (['000000', 'p000000', 'pundefined', null, undefined, 'ptest'].includes(value)) {
    return genericElementPicture;
  }

  const securityKey = HmacMD5(`p${value}`, 'pixl@cdn2securityKey').toString();

  return `https://contents.mediadecathlon.com/p${value}/k$${securityKey}/${name}.png/${size}/`;
};
